import { CLASS_NIVEAU_DISPONIBILITE, NON_DISPONIBLE } from '@/components/creationOpportunite/configuration/DisponibiliteConf';
import customArraySort from '@/services/general/customArraySort';
import { getFacesReseau } from '../../api/reseaux/index';
import store from '../../store/store';
import getMessageIndispoFace from './getMessageIndispoFace';

export default async function getFacesReseauAsync(
  reseauNum,
  query,
  listeFaces,
) {
  let copyListeFace = [];
  const isAffixe2 = store.getters['parametrage/affixe2'];
  const users = store.getters['user/users'];
  if (Array.isArray(listeFaces)) copyListeFace = listeFaces;
  if (!isAffixe2 && Object.prototype.hasOwnProperty.call(query.params, 'societeId')) {
    delete query.params.societeId;
  }
  const response = await getFacesReseau(reseauNum, query);
  response.data.forEach((el) => {
    el.dispoClass = CLASS_NIVEAU_DISPONIBILITE[el.dispo];
    if (isAffixe2) {
      el.messageIndisponibilite = getMessageIndispoFace(el.messageIndisponibilite, users);
    }
    const face = copyListeFace.find(face => face.facNum === el.facNum);
    if (face) {
      el.azimut = face.azimut;
      el.selected = face.selected;
      if ([NON_DISPONIBLE].includes(el.dispo)) {
        el.oldSelected = face.selected;
        el.selected = false;
      }
    } else {
      el.azimut = 0;
      el.selected = false;
    }
  });
  response.data.sort(customArraySort(['ville', 'panCode', 'facCode']));
  return response.data;
}



// WEBPACK FOOTER //
// ./src/services/reseauxTempo/getFaces.js